import React from 'react';
import { Helmet } from 'react-helmet';
import Layout from '../../components/digital-media/layout';
import { Container, makeStyles, Link, Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    paddingTop: '130px',
    [theme.breakpoints.up('md')]: {
      paddingTop: '96px',
    },
    borderBottom: '1px solid #e1e1e1',
  },
  slotholder: {
    backgroundImage: `url('/img/digital-media/t_standard.png')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: '50% 50%',
    width: '100%',
    height: '120px',
    [theme.breakpoints.up('md')]: {
      height: '200px',
    },
  },
  caption: {
    textAlign: 'center',
    color: 'white',
    fontSize: '30px',
    [theme.breakpoints.up('md')]: {
      fontSize: '48px',
      paddingTop: '65px',
      padingLeft: '90px',
    },
    paddingTop: '50px',
    paddingLeft: '80px',
  },
  captionEng: {
    textAlign: 'center',
    color: 'white',
    fontSize: '15px',
    [theme.breakpoints.up('md')]: {
      fontSize: '20px',
      paddingLeft: '320px',
    },
    paddingLeft: '200px',
    fontWeight: '200',
  },
  section1: {
    backgroundImage: `url('/img/digital-media/1231.png')`,
    backgroundRepeat: 'repeat-x',
    backgroundAttachment: 'scroll',
    backgroundPosition: 'top center',
    textAlign: 'center',
    fontsize: '16px',
    color: '#727272',
    paddingTop: '50px',
    paddingBottom: '50px',
  },
  section2: {
    paddingTop: '70px',
    marginLeft: '20px',
    marginRight: '20px',
  },
  hr: {
    lineHeight: '25px',
    borderColor: '#dddddd',
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    position: 'relative',
    margintTop: '15px',
    marginBottom: '30px',
  },
  contents: {
    color: '#666666',
    fontSize: '13px',
    margin: '0.85em 0',
    lineHeight: '1.65em',
  },
  icon: {
    paddingTop: '30px',
  },
}));

export default function CmsSolution() {
  const classes = useStyles();
  return (
    <Layout>
      <Helmet>
        <title>MALGN | KeyFlow ADAMS</title>
      </Helmet>
      <div className={classes.wrapper}>
        <div className={classes.slotholder}>
          <div className={classes.caption}>KeyFlow ADAMS</div>
          <div className={classes.captionEng}>CMS solution</div>
        </div>
        <div className={classes.section1}>
          <Container maxWidth="md">
            <p>
              기하급수적으로 증가하는 컨텐츠를 효과적으로 관리하고 싶으신가요?
            </p>
            <p>그럼 KeyFlow ADAMS와 함께 하십시오.</p>
            <p>KeyFlow ADAMS는 컨텐츠 소스의 다양화에 효과적으로 대응하며</p>
            <p>
              컨텐츠의 수집, 관리, 배급에 필요한 전 과정을 하나의 시스템으로
              쉽게 할 수 있도록 도와 드립니다.
            </p>
          </Container>
        </div>
      </div>

      <div className={classes.section2}>
        <Container maxWidth="md">
          <div>
            <h1>OVERVIEW </h1>
            <div className={classes.hr} />
            <Grid container spacing={10}>
              <Grid item xs={12} sm={6}>
                <h3>All-in-One 시스템</h3>
                <span className={classes.contents}>
                  컨텐츠 관리 시스템을 구축하는데 필요한 다양한 컴포넌트들을
                  통합하여 하나의 하드웨어에서 모든 기능을 수행합니다. 시스템을
                  구축하는데 복잡한 고민을 할 필요가 없으며, 구축 기간과 비용을
                  획기적으로 줄여줍니다. KeyFlow ADAMS와 함께 효율적인 컨텐츠
                  관리를 시작하십시오.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>데스크탑, 웹, 모바일 지원</h3>
                <span className={classes.contents}>
                  KeyFlow ADAMS의 클라이언트 환경은 현존하는 모든 플랫폼을
                  지원합니다. 보다 빠르고 편리한 기능을 제공하는 데스크탑
                  애플리케이션, 모든 플랫폼에서 동작하는 웹브라우저, 휴대성을
                  제공하는 전용의 모바일 애플리케이션을 통해 어느 기기에서나
                  원하는 일을 쉽게 하실 수 있습니다.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>손쉬운 관리</h3>
                <span className={classes.contents}>
                  KeyFlow ADAMS는 단 몇 번의 클릭으로 초기 설정을 완료할 수
                  있습니다. 관리자는 웹 인터페이스를 통해 컨텐츠, 사용자,
                  카테고리, 접근 권한 시스템 로그 등 시스템 운영에 필요한 다양한
                  부분들을 손쉽게 관리할 수 있습니다. IT 관련 전문 지식이
                  없더라도 충분히 관리가 가능합니다.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>직관적인 사용자 경험</h3>
                <span className={classes.contents}>
                  KeyFlow ADAMS에서 제공하는 사용자 환경은 매우 직관적입니다.
                  한번의 클릭 또는 터치를 통해 컨텐츠를 수집할 수 있으며, 드래그
                  앤 드랍 방식으로 컨텐츠를 원하는 곳에 전송할 수 있습니다.
                  이러한 직관적인 사용자 경험은 웹 및 모바일 환경에서도 동일하게
                  제공됩니다.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>외부 저작 애플리케이션 연계</h3>
                <span className={classes.contents}>
                  다년간 지상파 방송사에서 검증된 컨텐츠 관리 기능을
                  제공함으로써 컨텐츠 제작 업무의 생산성을 높여줍니다. 특히,
                  드래그 앤 드랍을 통한 주요 NLE 소프트웨어와의 연동, 전용의
                  플러그인 소프트웨어를 이용한 NLE 통합 환경은 정말
                  매력적입니다.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>다양한 포맷 지원</h3>
                <span className={classes.contents}>
                  KeyFlow ADAMS는 다양한 비디오 및 오디오 포맷, 5,000여개 이상의
                  디지털 카메라 이미지 포맷, PSD, PDF 등 업계 표준의 컨텐츠
                  포맷을 모두 지원합니다. 또한 MS Office 등 여러 가지 도큐멘트
                  파일을 손쉽게 가져오고 배포할 수 있습니다. 더 이상 컨텐츠 종류
                  때문에 고민하지 마십시오.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>뛰어난 장비 호환성</h3>
                <span className={classes.contents}>
                  KeyFlow ADAMS는 모든 종류의 스토리지와 함께 사용하실 수
                  있습니다. 기존의 스토리지 인프라에 기반하여 시스템을 구축할 수
                  있기 때문에 구축 비용을 절감할 수 있고, 작업 환경의 연속성이
                  보장되므로, 사용자들은 빠르게 새로운 업무 환경에 적응할 수
                  있습니다.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>편리한 공유와 활용</h3>
                <span className={classes.contents}>
                  인터넷에만 연결되어 있으면 KeyFlow ADAMS를 통해 관리되는 모든
                  컨텐츠에 손쉽게 접근할 수 있습니다. 모바일부터 웹, 데스크탑
                  애플리케이션까지 어느 곳에서나 원하는 컨텐츠를 검색 및
                  프리뷰하고 공유할 수 있습니다. 클라우드 작업 환경은 멀리 있지
                  않습니다.
                </span>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div className={classes.section2}>
        <Container maxWidth="md">
          <div>
            <h1>FEATURES</h1>
            <div className={classes.hr} />
            <Grid container spacing={10}>
              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      src="/img/digital-media/kfsicon_server.png"
                      className={classes.icon}
                      width="80px"
                      height="80px"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>KeyFlow S</h3>
                    <span className={classes.contents}>
                      CMS 엔진, 데이터베이스, 웹서버, 트랜스코더 등 컨텐츠 관리
                      시스템 구축에 필요한 모든 컴포넌트들이 하나로 통합되어
                      소프트웨어 패키지로 제공됩니다. 특히, 데이터베이스를
                      포함한 서버 정보들을 손쉽게 백업 및 복원 가능하기 때문에
                      유사시 빠르게 시스템을 복원할 수 있습니다. KeyFlow ADAMS
                      설치 과정은 일반 사용자 애플리케이션 설치처럼 매우
                      간단합니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      src="/img/digital-media/kfsicon_u.png"
                      className={classes.icon}
                      width="80px"
                      height="80px"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>KeyFlow U for Mac/Windows</h3>
                    <span className={classes.contents}>
                      KeyFlow U는 Mac과 Windows를 지원하는 사용자용 데스크탑
                      애플리케이션입니다. 이를 이용해 사용자는 쉽게 컨텐츠를
                      서버에 등록할 수 있고, 원하는 클립을 빠르게 검색 및 드래그
                      앤 드롭을 통한 외부 저작 애플리케이션과의 연동이
                      가능합니다. 특히, Mac에서는 Quicklook 기능을 이용해 동영상
                      파일 뿐만 아니라 오디오, 이미지, 일반 문서 파일까지 손쉽고
                      빠르게 프리뷰 할 수 있습니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item sm={6} xs={12}>
                <Grid container>
                  <Grid item sm={3} xs={12}>
                    <img
                      src="/img/digital-media/kfsicon_admin.png"
                      className={classes.icon}
                      width="80px"
                      height="80px"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>Web Service for Admin</h3>
                    <span className={classes.contents}>
                      관리자는 웹브라우저를 이용해서 사용자 및 그룹
                      추가/변경/삭제, 카테고리 추가/변경/삭제, 권한 설정, 컨텐츠
                      조회/삭제, 아카이브/리스토어 작업 관리 등의 필수적인 관리
                      업무를 수행할 수 있습니다. 이 외에도, 공지사항 작성,
                      시스템 로그 보기 등의 기능이 부가적으로 지원되며,
                      웹페이지의 머릿글과 바닥글을 작성할 수 있는 간단한 HTML
                      편집기를 제공합니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      src="/img/digital-media/kfsicon_web.png"
                      className={classes.icon}
                      width="80px"
                      height="80px"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>Web Service for User</h3>
                    <span className={classes.contents}>
                      Mac, Windows, Linux 어느 플랫폼에서나 웹브라우저를 통해
                      동일한 사용자 경험을 할 수 있습니다. 웹 서비스에 로그인을
                      하게 되면 자신에게 권한이 부여된 카테고리만 화면에
                      표시되고, 그 안의 컨텐츠들만 조회가 됩니다. 특히, 동영상
                      파일의 경우 다운로드 없이 바로 프리뷰를 할 수 있기 때문에
                      원하는 영상을 빠르고 정확하게 찾을 수 있습니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      src="/img/digital-media/kfsicon_trs.png"
                      className={classes.icon}
                      width="80px"
                      height="80px"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>External Transcoder</h3>
                    <span className={classes.contents}>
                      KeyFlow Server에는 기본적으로 저해상도 트랜스코더(H.264
                      영상 생성)가 내장되어 있습니다. H.264 영상은 웹 및 모바일
                      환경에서 해당 영상을 다운로드 없이 빠르게 프리뷰하는데
                      사용됩니다. 서버에 걸리는 부하 중 상당 부분이 트랜스코딩
                      작업 때문에 발생하게 되는데, 분산 인코딩을 통한 시스템
                      안정성 향상을 위해 트랜스코딩 작업만을 처리하는 별도의
                      하드웨어를 추가할 수 있습니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      src="/img/digital-media/kfsicon_ipad.png"
                      className={classes.icon}
                      width="80px"
                      height="80px"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>KeyFlow U for iPad</h3>
                    <span className={classes.contents}>
                      KeyFlow ADAMS 전용 iPad 앱을 통해 사용자는
                      앨범(카메라롤)에 저장되어 있거나 직접 촬영한 사진 및
                      동영상을 서버에 업로드 할 수 있습니다. 또한 서버에서 조회
                      혹은 검색한 사진 및 동영상을 다운로드하여 iPad 앨범에
                      저장할 수 있으며, 이를 iMovie와 같은 동영상 편집 앱에서
                      불러와 추가 작업을 할 수도 있습니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      src="/img/digital-media/AppIcon.png"
                      className={classes.icon}
                      width="80px"
                      height="80px"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>Archive Agent</h3>
                    <span className={classes.contents}>
                      KeyFlow ADAMS 단일 시스템 내에서 컨텐츠의 장기 보관을 위한
                      아카이브 및 리스토어 작업을 기본적으로 지원합니다.
                      직관적인 사용자 인터페이스로 작업 관리가 편리하며, 디스크
                      레이블 관리와 로그 조회 및 실시간 모니터링 모두
                      가능합니다. (하드디스크, LTFS, NAS, DAS 스토리지 지원)
                    </span>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      src="/img/digital-media/kfsicon_p5.png"
                      className={classes.icon}
                      width="80px"
                      height="80px"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>Advanced LTO Archive</h3>
                    <span className={classes.contents}>
                      Archiware의 P5와 연동하여 LTO 아카이브 및 리스토어를
                      수행할 수 있습니다. 또한, 메타 정보 및 프리뷰를 통해
                      아카이브된 컨텐츠를 리스토어하지 않고 미리 확인해 볼 수
                      있습니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item sm={6} xs={12}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      src="/img/digital-media/kfsicon_plugin.png"
                      className={classes.icon}
                      width="80px"
                      height="80px"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>NLE Plugin</h3>
                    <span className={classes.contents}>
                      KeyFlow ADAMS 구매시 현업에서 가장 많이 사용되고 있는 편집
                      애플리케이션들을 위한 플러그인 소프트웨어를 제공합니다.
                      이를 이용해, 사용자들은 편집 완료된 컨텐츠를 각
                      애플리케이션 내에서 KeyFlow ADAMS에 바로 등록할 수
                      있습니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      src="/img/digital-media/kfsicon_add.png"
                      className={classes.icon}
                      width="80px"
                      height="80px"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>Additional Function in Common</h3>
                    <span className={classes.contents}>
                      데스크탑, 웹, 모바일 애플리케이션에서 모두 컨텐츠에 대한
                      메타데이터를 추가 및 수정할 수 있습니다. 태그 입력 및 자동
                      완성 등의 편의 기능을 통해 쉽고 빠르게 컨텐츠를 검색 및
                      분류할 수 있고, 각 컨텐츠에 점수를 매기고, 필요한 코멘트를
                      남길 수도 있습니다. 시스템 로그인시 관리자가 작성한
                      공지사항이 자동으로 표시되는 기능도 제공합니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div
        className={classes.section2}
        style={{
          marginBottom: '200px',
        }}
      >
        <Container maxWidth="md">
          <div>
            <h1>WORKFLOW</h1>
            <div className={classes.hr} />
            <Grid container spacing={10}>
              <div
                style={{
                  marginTop: '30px',
                  paddingLeft: '10%',
                  paddingRight: '10%',
                }}
              >
                <img src="/img/digital-media/kfs_main_workflow02.png" />
              </div>
            </Grid>
          </div>
        </Container>
      </div>
    </Layout>
  );
}
